import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientsDisplayBodys } from 'components/ClientTable/ClientsDisplayBodys';

export interface ClientsDisplayState {
  currentClientBody: ClientsDisplayBodys;
}

export const initialState: ClientsDisplayState = {
  currentClientBody: ClientsDisplayBodys.ClientsMapDisplay,
};

const clientsSlice = createSlice({
  name: 'Clients',
  initialState,
  reducers: {
    setCurrentClientBody(state, action: PayloadAction<ClientsDisplayBodys>) {
      state.currentClientBody = action.payload;
    },
  },
});

export const { setCurrentClientBody } = clientsSlice.actions;
export default clientsSlice.reducer;
